import { useEffect, useState } from "react";

// Se eliminó la interfaz CalendarCardProps

const CalendarCard = ({ date, label }) => {
    const [day, setDay] = useState('00');
    const [month, setMonth] = useState('---');
    const [year, setYear] = useState('0000');

    useEffect(() => {
        if (date) {
            // Se eliminaron las anotaciones de tipo (: string, : number)
            const d = new Date(date);
            setDay(d.toLocaleDateString("es-ES", { day: "2-digit" }));
            setMonth(d.toLocaleDateString("es-ES", { month: "long" }));
            setYear(d.getFullYear().toString());
        }
    }, [date]);

    return (
        <div className="flex flex-col items-center w-32">
            <span className="text-sm font-medium text-gray-600 dark:text-gray-300 mb-1">
                {label}
            </span>

            <div className="bg-white dark:bg-gray-800 shadow-lg rounded-xl p-4 flex flex-col items-center w-full">

                {/* ICONO DE CALENDARIO */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-10 h-10 text-blue-600 mb-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.7}
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5A2 2 0 003 7v12a2 2 0 002 2z"
                    />
                </svg>

                {/* DÍA */}
                <span className="text-3xl font-bold text-gray-800 dark:text-white">
                    {day ?? "--"}
                </span>

                {/* MES */}
                <span className="text-sm capitalize text-gray-500 dark:text-gray-300">
                    {month ?? "--"}
                </span>
            </div>

            {/* AÑO (fuera del recuadro) */}
            <span className="mt-1 text-md font-semibold text-gray-700 dark:text-gray-200">
                {year ?? "----"}
            </span>
        </div>
    );
};

export default CalendarCard;